module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/LeaveRequestModal/Awaiting.ejs -->\n<div class="text-center"><strong>Awaiting approval</strong></div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/LeaveRequestModal/Awaiting.ejs
// module id = 900
// module chunks = 1